<template>
  <div class="flex-between">
    <el-date-picker
      v-model="start"
      :picker-options="startPickerOptions"
      type="date"
      size="small"
      value-format="yyyy-MM-dd"
      class="date-picker"
      @change="handleChange"
      placeholder="Start time">
    </el-date-picker>
    <el-date-picker
      v-model="end"
      :picker-options="endPickerOptions"
      size="small"
      type="date"
      value-format="yyyy-MM-dd"
      @change="handleChange"
      class="date-picker"
      placeholder="End time">
    </el-date-picker>
  </div>
</template>
<script>
export default {
  name: 'timeRange',
  props: {
    value: {
      type: Array,
      default: () => ['', ''],
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val.length == 2) {
          this.start = val[0]
          this.end = val[1]
        }
      }
    }
  },
  computed: {
    startPickerOptions({end}) {
      return {
        disabledDate(time) {
          return end ? time.getTime() > new Date(end).getTime() : false
        },
      }
    },
    endPickerOptions({start}) {
      return {
        disabledDate(time) {
          return start ? time.getTime() < new Date(start).getTime() : false
        },
      }
    }
  },
  data() {
    return {
      start: '',
      end: '',
    }
  },
  methods: {
    handleChange() {
      const value = [this.start, this.end]
      this.$emit('update:value', value)
      this.$emit('change')
    }
  }
}
</script>
<style lang="less" scope>
.flex-between {
  display: flex;
  justify-content: space-between;
}
.date-picker {
  width: 48%!important
}
</style>
